<template lang="pug">
    .buscar-territorios-py
        h1 {{ $t(`mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.tituloPY`) }}
        el-card
            .box-card-inserir-dados-manual
                .box-card-inserir-dados-manual__conteudo
                    .box-card-buscar-territorios
                        el-alert.alert-destaque(
                            type='info',
                            show-icon,
                            :closable='false',
                            effect='light'
                        )
                            template(slot='title')
                                strong {{ $t(`mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.argentina.instrucoes`) }}
                            | {{ $t(`mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.paraguai.textoUnificado`) }}
                        .secoes-busca-container
                            .secao-busca-doc
                                h2.secao-titulo-territorios {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.paraguai.pesquisaProdutor') }}
                                p.secao-descricao
                                    | {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.paraguai.descricaoPesquisaProdutor') }}

                                .secao-pesquisa-documento
                                    el-form.form-pesquisa-documento(
                                        label-position='top',
                                        :model='formularioCadastroTerritorio',
                                        :rules='formularioCadastroTerritorioRegras',
                                        ref='formularioCadastroTerritorio'
                                    )
                                        .box-card-inserir-dados-manual__conteudo__bloco_pesquisa-por-territorio.width-direito
                                            el-form-item(:prop='computedPropCpfCpnj')
                                                .input-pesquisa-por-territorio-container
                                                    .input-pesquisa-por-territorio.input-car-cpf-cnpj
                                                        el-select(
                                                            v-model='formularioCadastroTerritorio.documentoPessoa',
                                                            :loading='buscandoRepresentante',
                                                            :loading-text='textoBuscandoRepresentante',
                                                            filterable,
                                                            remote,
                                                            clearable,
                                                            @clear='limparCPF',
                                                            :placeholder='$t(`mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.buscaPorDocumentoPY`)',
                                                            remote-show-suffix,
                                                            ref='selectCpfCnpj',
                                                            :remote-method='buscarRepresentanteNomeOuCpfCnpj',
                                                            :disabled='loadingResumo'
                                                        )
                                                            el-option(
                                                                v-for='representante in representantes',
                                                                :key='representante.id',
                                                                :label='representante.cpfCnpj',
                                                                :value='representante.id'
                                                            )
                                                                .input-pesquisa-por-representante-select
                                                                    span {{ representante.nomeRazaoSocial }}
                                                                    span.direita {{ 'Documento: ' + representante.cpfCnpj + '' }}
                                                    el-button(
                                                        type='primary',
                                                        icon='el-icon-search',
                                                        @click.prevent='buscarTerritoriosVinculados',
                                                        :disabled='!formularioCadastroTerritorio.documentoPessoa || loadingResumo'
                                                    ) {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.argentina.buscar') }}

                            .secao-busca-territorios-cadastrados
                                h2.secao-titulo-territorios {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.paraguai.tituloBuscarTerritoriosCadastrados') }}
                                p.secao-descricao
                                    | {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.paraguai.descricaoBuscarTerritoriosCadastrados') }}
                                el-button(
                                    type='primary',
                                    icon='el-icon-search',
                                    @click='abrirModalBuscarTerritorios',
                                    :disabled='loadingResumo || territoriosSelecionados.length >= limiteTerritoriosSelecionados'
                                ) {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.paraguai.botaoBuscarTerritoriosCadastrados') }}

                    .box-card-buscar-territorios.secao-localizacao
                        h2.secao-titulo {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.argentina.pesquisaDados') }}

                        el-form.formTerritorios(
                            label-position='top',
                            :model='formBuscaTerritorios',
                            :rules='formBuscaTerritoriosRegras',
                            ref='formCadastroManualRef'
                        )
                            el-form-item(
                                :label='$t("mensagens.diagnosticoSocioambiental.propriedadesCamada.departamento")',
                                prop='departamento'
                            )
                                el-select#departamento(
                                    v-model='formBuscaTerritorios.departamento',
                                    v-loading='carregandoNivelUm',
                                    :placeholder='$t("mensagens.comuns.selecione")',
                                    clearable,
                                    filterable,
                                    @change='handleDepartamentoChange',
                                    @clear='handleDistritoClear'
                                )
                                    el-option(
                                        v-for='departamento in departamentos',
                                        :key='departamento.id',
                                        :label='departamento.label',
                                        :value='departamento.id'
                                    )

                            el-form-item(
                                :label='$t("mensagens.diagnosticoSocioambiental.propriedadesCamada.dist")',
                                prop='distrito'
                            )
                                el-select#distrito(
                                    v-model='formBuscaTerritorios.distrito',
                                    v-loading='carregandoNivelDois',
                                    :placeholder='$t("mensagens.comuns.selecione")',
                                    clearable,
                                    filterable,
                                    :disabled='!formBuscaTerritorios.departamento'
                                )
                                    el-option(
                                        v-for='distrito in distritos',
                                        :key='distrito.id',
                                        :label='distrito.label',
                                        :value='distrito.id'
                                    )

                            el-form-item(label='Finca')
                                el-input#finca(
                                    v-model='formBuscaTerritorios.finca',
                                    :placeholder='$t("mensagens.comuns.placeholder")',
                                    maxlength='10',
                                    clearable
                                )

                            el-form-item(label='Padrón')
                                el-input#padron(
                                    v-model='formBuscaTerritorios.padron',
                                    :placeholder='$t("mensagens.comuns.placeholder")',
                                    maxlength='10',
                                    clearable
                                )

                            el-button(
                                type='primary',
                                icon='el-icon-search',
                                @click='buscarTerritorio',
                                :loading='buscandoTerritorio',
                                :disabled='!isFormValido || loadingResumo'
                            ) {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.argentina.buscar') }}

                        el-collapse.accordion-territorios-selecionados(
                            v-if='temTerritoriosParaExibir',
                            v-model='accordionTerritoriosAtivo'
                        )
                            el-collapse-item(
                                :title='$t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.paraguai.tituloAccordionTerritoriosSelecionados")',
                                name='territorios'
                            )
                                .listas-territorios-container
                                    .lista-pendentes
                                        .lista-header
                                            .lista-titulo-container
                                                h4.lista-titulo {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.paraguai.pendentesDeAnalise') }}
                                            p.lista-descricao {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.paraguai.descricaoPendentesDeAnalise') }}
                                        el-table.lista-territorios-table(
                                            v-if='territoriosSelecionados.length > 0',
                                            :data='territoriosSelecionados',
                                            stripe,
                                            border
                                        )
                                            el-table-column(width='50')
                                                template(slot='header', slot-scope='_')
                                                    el-checkbox(
                                                        :value='todosPendentesSelectionados',
                                                        :indeterminate='algunsPendentesSelectionados',
                                                        @change='toggleSelecionarTodosPendentes'
                                                    )
                                                template(slot-scope='scope')
                                                    el-checkbox(
                                                        :value='idsSelecionadosParaAcao.includes(scope.row.id)',
                                                        @change='toggleTerritorioSelecao(scope.row.id)'
                                                    )
                                            el-table-column(
                                                min-width='200'
                                            )
                                                template(slot='header')
                                                    .table-header-with-icon
                                                        i.el-icon-location-outline.table-header-icon
                                                        span {{ $t("mensagens.relatorioRastreabilidade.cadastro.territorio") }}
                                                template(slot-scope='scope')
                                                    .table-cell-territorio
                                                        span.table-nome {{ scope.row.nome || $t('mensagens.sig.erro.naoinformado') }}
                                            el-table-column(
                                                width='120'
                                            )
                                                template(slot='header')
                                                    .table-header-with-icon
                                                        i.el-icon-document.table-header-icon
                                                        span {{ $t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.paraguai.finca") }}
                                                template(slot-scope='scope')
                                                    span {{ scope.row.finca || '-' }}
                                            el-table-column(
                                                width='120'
                                            )
                                                template(slot='header')
                                                    .table-header-with-icon
                                                        i.el-icon-document.table-header-icon
                                                        span {{ $t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.paraguai.padron") }}
                                                template(slot-scope='scope')
                                                    span {{ scope.row.padron || '-' }}
                                            el-table-column(
                                                min-width='200'
                                            )
                                                template(slot='header')
                                                    .table-header-with-icon
                                                        i.el-icon-map-location.table-header-icon
                                                        span {{ $t("mensagens.relatorioRastreabilidade.cadastro.distritoDepartamento") }}
                                                template(slot-scope='scope')
                                                    span {{ getDepartamentoDistritoTextoTerritorio(scope.row) }}
                                        .lista-vazia(v-else)
                                            el-empty(
                                                :description='$t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.paraguai.listaVaziaPendentes")',
                                                :image-size='80'
                                            )
                                        .lista-acoes(v-if='territoriosSelecionados.length > 0')
                                            .lista-botoes
                                                el-button(
                                                    type='default',
                                                    icon='el-icon-refresh',
                                                    :disabled='!idsSelecionadosParaAcao.length || loadingResumo',
                                                    @click='limparSelecionadosPendentes'
                                                ) {{ $t('mensagens.operacao.acoes.limparSelecao') }}
                                                .botao-analisar-container
                                                    el-button(
                                                        type='primary',
                                                        icon='el-icon-search',
                                                        :disabled='!idsSelecionadosParaAcao.length || loadingResumo',
                                                        :loading='loadingResumo',
                                                        @click.prevent='enviarSelecionadosParaAnalise'
                                                    ) {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.analisarElegibilidade') }}
                                                    el-tooltip(
                                                        v-if='idsSelecionadosParaAcao.length > 1',
                                                        effect='dark',
                                                        :content='$t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.paraguai.analiseSequencial")',
                                                        placement='top'
                                                    )
                                                        i.el-icon-info.lista-info-icon

                                    el-divider

                                    .lista-analisados
                                        .lista-header
                                            .lista-titulo-container
                                                h4.lista-titulo {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.paraguai.jaAnalisados') }}
                                            p.lista-descricao {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.paraguai.descricaoJaAnalisados') }}
                                        el-table.lista-territorios-table.lista-territorios-table--analisados(
                                            ref='tableTerritoriosAnalisados',
                                            v-if='territoriosAnalisados.length > 0',
                                            :data='territoriosAnalisados',
                                            stripe,
                                            border,
                                            row-key='territorio.id'
                                        )
                                            el-table-column(width='50')
                                                template(slot='header', slot-scope='_')
                                                    el-checkbox(
                                                        :value='todosAnalisadosSelectionados',
                                                        :indeterminate='algunsAnalisadosSelectionados',
                                                        @change='toggleSelecionarTodosAnalisados'
                                                    )
                                                template(slot-scope='scope')
                                                    el-checkbox(
                                                        :value='idsSelecionadosParaAdicionarLista.includes(scope.row.territorio.id)',
                                                        :disabled='scope.row.resultadoElegibilidade === "INELEGIVEL"',
                                                        @change='toggleTerritorioAnalisadoSelecao(scope.row.territorio.id)'
                                                    )
                                            el-table-column(type='expand', width='40')
                                                template(slot-scope='scope')
                                                    .box-espande-listagem
                                                        .box-espande-listagem-box
                                                            .box-espande-listagem-box-texto {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.diagnosticoSocioambiental') }}
                                                            .box-espande-listagem-box-value
                                                                el-tag(
                                                                    size='small',
                                                                    :type='corTagElegibilidade(scope.row.resultadoElegibilidade)'
                                                                ) {{ textoElegibilidade(scope.row.resultadoElegibilidade) }}
                                                        .box-espande-listagem-box
                                                            .box-espande-listagem-box-texto {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.saldoDisponivel') }}
                                                            .box-espande-listagem-box-value {{ formatSaldoDisponivel(scope.row.dadosAnaliseElegibilidade) }}
                                                        .box-espande-listagem-box
                                                            .box-espande-listagem-box-texto {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.distancia') }}
                                                            .box-espande-listagem-box-value
                                                                span {{ formatDistancia(scope.row.dadosAnaliseElegibilidade) }}
                                                        .box-espande-listagem-box
                                                            el-button.bt-link(
                                                                type='text',
                                                                size='small',
                                                                @click='abrirDetalhesElegibilidade(scope.row)'
                                                            ) {{ $t('mensagens.comuns.verDetalhes') }}
                                            el-table-column(
                                                min-width='200'
                                            )
                                                template(slot='header')
                                                    .table-header-with-icon
                                                        i.el-icon-location-outline.table-header-icon
                                                        span {{ $t("mensagens.relatorioRastreabilidade.cadastro.territorio") }}
                                                template(slot-scope='scope')
                                                    .table-cell-territorio
                                                        span.table-nome {{ scope.row.territorio.nome || $t('mensagens.sig.erro.naoinformado') }}
                                            el-table-column(
                                                width='120'
                                            )
                                                template(slot='header')
                                                    .table-header-with-icon
                                                        i.el-icon-document.table-header-icon
                                                        span {{ $t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.paraguai.finca") }}
                                                template(slot-scope='scope')
                                                    span {{ scope.row.territorio.finca || '-' }}
                                            el-table-column(
                                                width='120'
                                            )
                                                template(slot='header')
                                                    .table-header-with-icon
                                                        i.el-icon-document.table-header-icon
                                                        span {{ $t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.paraguai.padron") }}
                                                template(slot-scope='scope')
                                                    span {{ scope.row.territorio.padron || '-' }}
                                            el-table-column(
                                                min-width='200'
                                            )
                                                template(slot='header')
                                                    .table-header-with-icon
                                                        i.el-icon-map-location.table-header-icon
                                                        span {{ $t("mensagens.relatorioRastreabilidade.cadastro.distritoDepartamento") }}
                                                template(slot-scope='scope')
                                                    span {{ getDepartamentoDistritoTextoTerritorio(scope.row.territorio) }}
                                            el-table-column(
                                                :label='$t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.paraguai.informarVolume")',
                                                min-width='250'
                                            )
                                                template(slot-scope='scope')
                                                    .table-volume-container
                                                        el-input.table-volume-input(
                                                            v-model='scope.row.volume',
                                                            :placeholder='$t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.paraguai.placeholderVolume")',
                                                            size='small',
                                                            :class='{ "is-error": errosVolume[scope.$index] }',
                                                            :disabled='scope.row.resultadoElegibilidade === "INELEGIVEL"',
                                                            @blur='formatarVolumeAnalisado(scope.$index)'
                                                        )
                                                        span.input-volume-erro(v-if='errosVolume[scope.$index]') {{ errosVolume[scope.$index] }}
                                            el-table-column(
                                                :label='$t("mensagens.comuns.acoes")',
                                                width='180',
                                                fixed='right'
                                            )
                                                template(slot-scope='scope')
                                                    el-button(
                                                        type='primary',
                                                        size='small',
                                                        icon='el-icon-arrow-down',
                                                        style='min-width: 112px',
                                                        @click='toggleExpandRowAnalisado(scope.row)'
                                                    ) {{ $t('mensagens.comuns.expandir') }}
                                        .lista-acoes(v-if='territoriosAnalisados.length > 0')
                                            .lista-botoes
                                                el-button(
                                                    type='default',
                                                    icon='el-icon-refresh',
                                                    :disabled='!idsSelecionadosParaAdicionarLista.length || loadingAdicionarLista',
                                                    @click='limparSelecionadosParaAdicionarLista'
                                                ) {{ $t('mensagens.operacao.acoes.limparSelecao') }}
                                                el-button(
                                                    type='danger',
                                                    icon='el-icon-delete',
                                                    :disabled='!temInelegiveis || loadingAdicionarLista',
                                                    @click='removerInelegiveis'
                                                ) {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.paraguai.removerInelegiveis') }}
                                                el-button(
                                                    type='primary',
                                                    icon='el-icon-plus',
                                                    :disabled='!idsSelecionadosParaAdicionarLista.length || loadingAdicionarLista || !selecionadosParaAdicionarComVolumeValido',
                                                    :loading='loadingAdicionarLista',
                                                    @click.prevent='enviarSelecionadosParaAdicionarLista'
                                                ) {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.adicionarLista') }}
                                        .lista-vazia(v-else)
                                            el-empty(
                                                :description='$t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.paraguai.listaVaziaAnalisados")',
                                                :image-size='80'
                                            )

                        SubEmpresaBlocoResumoElegibilidade(
                            v-if='showResumoElegibilidade',
                            :dadosAnaliseElegibilidade='dadosAnaliseElegibilidade',
                            :resultadoElegibilidade='resultadoElegibilidade',
                            :formularioCadastroTerritorio='formularioCadastroTerritorio',
                            :loadingResumo='loadingResumo',
                            :territorioSendoInserido='territorioSendoInserido',
                            :mostrarCodigoCar='mostrarCodigoCar',
                            :volumeDisponivelContrato='volumeDisponivelContrato'
                            @modal-analise-elegibilidade='modalAnaliseElegibilidade',
                            @validar-territorio-manual='validarTerritorioManual',
                            @volume-formatado='volumeRecebidoFormatado'
                        )

        ModalBuscarTerritoriosCadastradosPy(
            :show='showModalBuscarTerritorios',
            :ids-territorios-em-uso='idsTerritoriosEmUso',
            @voltar='fecharModalBuscarTerritorios',
            @retornarDadosSelecionados='handleTerritorioSelecionadoModal'
        )
    </template>

    <script>
    import SubEmpresaBlocoResumoElegibilidade from './SubEmpresaBlocoResumoElegibilidade.vue';
    import ModalBuscarTerritoriosCadastradosPy from './ModalBuscarTerritoriosCadastradosPy.vue';
    import ContratoOriginacaoServiceSubEmpresa from '@/services/ContratoOriginacaoServiceSubEmpresa';
    import RepresentanteService from '@/services/RepresentanteService';
    import TerritorioService from '@/services/TerritorioService';
    import LocalidadeService from '@/services/LocalidadeService';
    import formatters from '@/utils/formatters';
    import validators from '@/utils/validators';

    const LIMITE_TERRITORIOS_SELECIONADOS = 10;

    export default {
        name: 'SubEmpresaCardBuscaTerritoriosPY',
        components: {
            SubEmpresaBlocoResumoElegibilidade,
            ModalBuscarTerritoriosCadastradosPy,
            validators
        },

        props: {
            volumeDisponivelContrato: {
                type: Number,
                required: true
            },
            dados: {
                type: Object,
                required: true
            },
            numeroContrato: {
                type: String,
                required: true
            },
            isRastreabilidadeOffline: {
                type: Boolean,
                required: true
            }
        },

        mounted() {
            this.listarLocalidadeNivelUm();
        },

        data() {
            const validarFincaPadron = (rule, value, callback) => {
                if (value === '') {
                    callback(
                        new Error(
                            this.$t(
                                'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.campoObrigatorio'
                            )
                        )
                    );
                    return;
                }
                callback();
            };

            return {
                formBuscaTerritorios: {
                    departamento: null,
                    distrito: null,
                    padron: null,
                    finca: null
                },
                formBuscaTerritoriosRegras: {
                    departamento: [
                        {
                            required: true,
                            message: this.$t('mensagens.comuns.campoObrigatorio'),
                            trigger: 'change'
                        }
                    ]
                },
                formularioCadastroTerritorio: {
                    volumeTerritorio: '',
                    territorioSelecionado: '',
                    documentoPessoa: {}
                },
                formularioCadastroTerritorioRegras: {
                    territorioSelecionado: [
                        {
                            required: true,
                            validator: validarFincaPadron,
                            trigger: 'change'
                        }
                    ]
                },
                // Estados de carregamento
                carregandoNivelUm: false,
                carregandoNivelDois: false,
                carregandoNivelTres: false,
                buscandoTerritorio: false,
                loadingResumo: false,
                territorioSendoInserido: false,
                buscandoRepresentante: false,

                // Dados das localidades
                departamentos: [],
                distritos: [],
                localidades: [],

                // Dados dos representantes
                representantes: [],
                territoriosVinculados: [],
                textoBuscandoRepresentante: '',
                inputValueRepresentante: '',

                // Territórios selecionados (lista múltipla)
                territoriosSelecionados: [],
                territoriosAnalisados: [],
                idsSelecionadosParaAcao: [],
                idsSelecionadosParaAdicionarLista: [],
                accordionTerritoriosAtivo: ['territorios'],
                itemInserindoId: null,
                loadingAdicionarLista: false,
                errosVolume: {},

                // Território em análise (resumo) - um por vez
                territorioSelecionado: null,
                buscaRealizada: false,
                tipoSelecao: '', // 'documento' ou 'localizacao'

                // Dados de elegibilidade
                resultadoElegibilidade: 'INDEFINIDO',
                dadosAnaliseElegibilidade: this.getInitialDadosAnalise(),
                showResumoElegibilidade: false,

                debounceTimer: null,

                // Modal buscar territórios cadastrados
                showModalBuscarTerritorios: false,

                limiteTerritoriosSelecionados: LIMITE_TERRITORIOS_SELECIONADOS
            };
        },

        watch: {
            'formBuscaTerritorios.departamento'(newVal) {
                if (newVal) {
                    this.handleDepartamentoChange();
                }
            },
            'formularioCadastroTerritorio.territorioSelecionadoDocumento':
                function (newVal) {
                    if (newVal) {
                        this.limparDadosResumo();
                    }
                },
            'formularioCadastroTerritorio.documentoPessoa': function (newVal) {
                if (newVal) {
                    this.limparDadosResumo();
                    this.territoriosVinculados = [];
                    this.formularioCadastroTerritorio.territorioSelecionadoDocumento =
                        '';
                }
            }
        },

        computed: {
            computedPropCpfCpnj() {
                return !this.isRastreabilidadeOffline ? 'documentoPessoa' : '';
            },

            isFormValido() {
                const { departamento } = this.formBuscaTerritorios;
                return departamento;
            },

            isButtonEnabledDocumento() {
                return (
                    this.formularioCadastroTerritorio.documentoPessoa &&
                    Object.keys(this.formularioCadastroTerritorio.documentoPessoa)
                        .length > 0 &&
                    this.formularioCadastroTerritorio
                        .territorioSelecionadoDocumento !== ''
                );
            },

            mostrarCodigoCar() {
                return this.tipoSelecao !== 'documento';
            },

            temTerritoriosParaExibir() {
                return (
                    this.territoriosSelecionados.length > 0 ||
                    this.territoriosAnalisados.length > 0
                );
            },

        todosPendentesSelectionados() {
            return (
                this.territoriosSelecionados.length > 0 &&
                this.idsSelecionadosParaAcao.length === this.territoriosSelecionados.length
            );
        },

        algunsPendentesSelectionados() {
            return (
                this.idsSelecionadosParaAcao.length > 0 &&
                this.idsSelecionadosParaAcao.length < this.territoriosSelecionados.length
            );
        },

        todosAnalisadosSelectionados() {
            const elegíveis = this.territoriosAnalisados.filter(
                (r) => r.resultadoElegibilidade !== 'INELEGIVEL'
            );
            return (
                elegíveis.length > 0 &&
                this.idsSelecionadosParaAdicionarLista.length === elegíveis.length
            );
        },

        algunsAnalisadosSelectionados() {
            const elegíveis = this.territoriosAnalisados.filter(
                (r) => r.resultadoElegibilidade !== 'INELEGIVEL'
            );
            return (
                this.idsSelecionadosParaAdicionarLista.length > 0 &&
                this.idsSelecionadosParaAdicionarLista.length < elegíveis.length
            );
        },

            temInelegiveis() {
                return this.territoriosAnalisados.some(
                    (r) => r.resultadoElegibilidade === 'INELEGIVEL'
                );
            },

            selecionadosParaAdicionarComVolumeValido() {
                if (!this.idsSelecionadosParaAdicionarLista.length) return true;
                const selected = this.territoriosAnalisados.filter((row) =>
                    this.idsSelecionadosParaAdicionarLista.includes(row.territorio.id)
                );
                return selected.every((row) => this.volumeValido(row.volume, row));
            },

            idsTerritoriosEmUso() {
                return [
                    ...this.territoriosSelecionados.map((territorio) => territorio.id),
                    ...this.territoriosAnalisados.map((item) => item.territorio.id)
                ];
            },

            fincaPadronDisplay() {
                const territorio =
                    this.formularioCadastroTerritorio.territorioSelecionado;
                const finca = territorio?.finca;
                const padron = territorio?.padron;

                const fincaValida =
                    finca !== null &&
                    finca !== undefined &&
                    finca !== 'null' &&
                    String(finca).trim() !== '';
                const padronValida =
                    padron !== null &&
                    padron !== undefined &&
                    padron !== 'null' &&
                    String(padron).trim() !== '';

                return fincaValida && padronValida ? `${finca} / ${padron}` : '-';
            }
        },

        methods: {
            getInitialDadosAnalise() {
                return {
                    elegibilidade: '',
                    valor: '',
                    cpfCnpj: '',
                    safraNome: '',
                    dadosDiagnostico: {
                        diagnosticoRepresentante: [],
                        diagnosticoCar: null,
                        resultadoDiagnosticoRastreabilidade: null,
                        nivelAlertaRastreabilidade: null
                    },
                    dadosCalculoRaio: {
                        distanciaRaioLocalidade: null,
                        possuiIntersecao: null,
                        siglaEstadoContrato: null,
                        distanciaPermitida: null
                    },
                    dadosRestricaoEstado: {
                        possuiRestricaoEstado: null,
                        siglaEstadoCar: null,
                        siglaEstadoPermitido: null
                    },
                    dadosBuscaSaldo: {
                        id: null,
                        codigoCar: '',
                        capacidadeProdutiva: null,
                        saldoCARcapacidadeProdutiva: null,
                        calculoSaca: {
                            saldoCARcapacidadeProdutivaSaca: null,
                            saldoCarComprometido: null
                        },
                        cultura: {
                            id: null,
                            nome: '',
                            codigo: ''
                        },
                        anoSafra: {
                            id: null,
                            ano: null,
                            tipoSafra: '',
                            descricao: ''
                        },
                        criadoEm: null,
                        saldoCarComprometido: null
                    },
                    territorioOutput: {
                        finca: null,
                        padron: null,
                        geom: null,
                        idTerritorio: null,
                        nomeTerritorio: null
                    }
                };
            },

            async buscarRepresentanteNomeOuCpfCnpj(filtro) {
                clearTimeout(this.debounceTimer);

                this.debounceTimer = setTimeout(async () => {

                    this.buscandoRepresentante = true;

                    filtro = filtro.replace(/[^\w\s]/gi, '');

                    try {
                        this.textoBuscandoRepresentante = 'Carregando...';
                        const { data } =
                            await RepresentanteService.buscarPorNomeOuCpfCnpj(filtro);
                        this.representantes = data;
                    } catch (error) {
                        this.$notify.error({
                            message: this.$t(
                                'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.erroRequisicao'
                            )
                        });
                    } finally {
                        this.buscandoRepresentante = false;
                    }
                }, 500);
            },

            async buscarTerritoriosVinculados() {
                if (!this.formularioCadastroTerritorio.documentoPessoa) {
                    this.$notify.warning({
                        message: this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.selecioneRepresentante'
                        )
                    });
                    return;
                }

                try {
                    const { data } =
                        await TerritorioService.buscarTerritoriosVinculadosPessoaPY(
                            this.formularioCadastroTerritorio.documentoPessoa,
                            this.numeroContrato
                        );

                    if (data.itens.length) {
                        this.$emit('modal-territorios', data.itens);
                        this.tipoSelecao = 'documento';
                    } else {
                        this.alertRepresentanteSemTerritorios();
                    }
                } catch (error) {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.erroRequisicao'
                        )
                    });
                }
            },

            definirTerritorioSelecionado(territorio) {
                if (!territorio) return;
                this.definirTerritoriosSelecionados([territorio]);
            },

            territorioJaEstaNaListagem(id) {
                return this.idsTerritoriosEmUso.includes(id);
            },

            notificarTerritorioJaNaListagem() {
                this.$notify.warning({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.paraguai.territorioJaNaListagem'
                    )
                });
            },

            definirTerritoriosSelecionados(territorios) {
                if (!territorios || !territorios.length) return;
                const idsExistentes = new Set(this.idsTerritoriosEmUso);
                const vagasRestantes =
                    LIMITE_TERRITORIOS_SELECIONADOS -
                    this.territoriosSelecionados.length;
                let adicionados = 0;
                let ignoradosPorDuplicidade = 0;

                territorios.forEach((t) => {
                    if (!t || !t.id) return;

                    if (idsExistentes.has(t.id)) {
                        ignoradosPorDuplicidade++;
                        return;
                    }

                    if (adicionados < vagasRestantes) {
                        this.territoriosSelecionados.push(t);
                        idsExistentes.add(t.id);
                        adicionados++;
                    }
                });

                if (ignoradosPorDuplicidade > 0) {
                    this.notificarTerritorioJaNaListagem();
                }

                if (territorios.length - ignoradosPorDuplicidade > adicionados) {
                    this.$notify.warning({
                        message: this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.paraguai.limiteMaximoTerritoriosSelecionados'
                        )
                    });
                }
            },

            getDepartamentoDistritoTextoTerritorio(t) {
                if (!t) return this.$t('mensagens.sig.erro.naoinformado');
                const { departamento, distrito, departamentoNome, distritoNome } = t;
                if (departamento && distrito) {
                    return `${distrito.nome} / ${departamento.nome}`;
                }
                if (departamentoNome && distritoNome) {
                    return `${distritoNome} / ${departamentoNome}`;
                }
                return this.$t('mensagens.sig.erro.naoinformado');
            },

        toggleSelecionarTodosPendentes() {
            if (this.todosPendentesSelectionados) {
                this.idsSelecionadosParaAcao = [];
            } else {
                this.idsSelecionadosParaAcao = this.territoriosSelecionados.map((t) => t.id);
            }
        },

        toggleSelecionarTodosAnalisados() {
            if (this.todosAnalisadosSelectionados) {
                this.idsSelecionadosParaAdicionarLista = [];
            } else {
                this.idsSelecionadosParaAdicionarLista = this.territoriosAnalisados
                    .filter((r) => r.resultadoElegibilidade !== 'INELEGIVEL')
                    .map((r) => r.territorio.id);
            }
        },

            toggleTerritorioSelecao(id) {
                const idx = this.idsSelecionadosParaAcao.indexOf(id);
                if (idx >= 0) {
                    this.idsSelecionadosParaAcao.splice(idx, 1);
                } else {
                    this.idsSelecionadosParaAcao.push(id);
                }
            },

            limparSelecionadosPendentes() {
                if (!this.idsSelecionadosParaAcao.length) return;
                this.territoriosSelecionados = this.territoriosSelecionados.filter(
                    (t) => !this.idsSelecionadosParaAcao.includes(t.id)
                );
                this.idsSelecionadosParaAcao = [];
            },

            toggleTerritorioAnalisadoSelecao(id) {
                const idx = this.idsSelecionadosParaAdicionarLista.indexOf(id);
                if (idx >= 0) {
                    this.idsSelecionadosParaAdicionarLista.splice(idx, 1);
                } else {
                    this.idsSelecionadosParaAdicionarLista.push(id);
                }
            },

            limparSelecionadosParaAdicionarLista() {
                this.idsSelecionadosParaAdicionarLista = [];
            },

            removerInelegiveis() {
                const idsInelegiveis = this.territoriosAnalisados
                    .filter((r) => r.resultadoElegibilidade === 'INELEGIVEL')
                    .map((r) => r.territorio.id);
                this.territoriosAnalisados = this.territoriosAnalisados.filter(
                    (r) => r.resultadoElegibilidade !== 'INELEGIVEL'
                );
                this.idsSelecionadosParaAdicionarLista =
                    this.idsSelecionadosParaAdicionarLista.filter(
                        (id) => !idsInelegiveis.includes(id)
                    );
            },

            toggleExpandRowAnalisado(row) {
                const table = this.$refs.tableTerritoriosAnalisados;
                if (table) {
                    table.toggleRowExpansion(row);
                }
            },

            parseVolume(str) {
                const num = parseFloat(
                    String(str || '').replace(',', '.').replace(/\s/g, '')
                );
                return Number.isNaN(num) ? 0 : num;
            },

            buildPayloadInserirPY(item) {
                const { territorio } = item;
                return {
                    idTerritorio: territorio.id,
                    numeroContrato: this.numeroContrato,
                    volume: this.parseVolume(item.volume),
                    documentoRepresentante: territorio.idRepresentante || territorio.representantes[0].id,
                    idRepresentante: this.getIdRepresentante(territorio)
                };
            },

            async enviarSelecionadosParaAdicionarLista() {
                if (
                    !this.idsSelecionadosParaAdicionarLista.length ||
                    this.loadingAdicionarLista
                ) {
                    return;
                }
                const selecionados = this.territoriosAnalisados.filter((row) =>
                    this.idsSelecionadosParaAdicionarLista.includes(
                        row.territorio.id
                    )
                );
                const semVolumeValido = selecionados.filter(
                    (row) => !this.volumeValido(row.volume, row)
                );
                if (semVolumeValido.length > 0) {
                    this.$notify.warning({
                        message: this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.paraguai.informeVolumeSelecionados'
                        )
                    });
                    return;
                }

                this.loadingAdicionarLista = true;
                const idsSelecionados = selecionados.map((item) => item.territorio.id);
                try {
                    const listaPayloads = selecionados.map((item) =>
                        this.buildPayloadInserirPY(item)
                    );
                    const { data } =
                        await ContratoOriginacaoServiceSubEmpresa.inserirDadosContratoPY(
                            listaPayloads
                        );
                    if (data.mensagemCadastroSucesso) {
                        this.$notify.success({
                            message: data.mensagemCadastroSucesso
                        });
                    }
                    this.territoriosAnalisados = this.territoriosAnalisados.filter(
                        (i) => !idsSelecionados.includes(i.territorio.id)
                    );
                    this.idsSelecionadosParaAdicionarLista =
                        this.idsSelecionadosParaAdicionarLista.filter(
                            (id) => !idsSelecionados.includes(id)
                        );
                    this.$emit('territorio-inserido');
                } catch (error) {
                    this.exibirNotificacoesErros(error);
                } finally {
                    this.loadingAdicionarLista = false;
                }
            },

            getIdRepresentante(territorio) {
                if (this.tipoSelecao === 'documento') {
                    return this.formularioCadastroTerritorio.documentoPessoa;
                }
                const id =
                    territorio?.idRepresentante ||
                    territorio?.representantes?.[0]?.id;
                return id ?? this.formularioCadastroTerritorio.documentoPessoa;
            },

            buildBodyResumoElegibilidade(idTerritorios) {
                const primeiro = this.territoriosSelecionados.find((t) =>
                    idTerritorios.includes(t.id)
                );
                const idRepresentante = this.getIdRepresentante(primeiro);
                return {
                    numeroContrato: this.numeroContrato,
                    idRepresentante: idRepresentante == null ? 0 : idRepresentante,
                    idTerritorios
                };
            },

            mapRespostaParaDadosAnalise(resposta) {
                const base = this.getInitialDadosAnalise();
                const resultado =
                    resposta.resultadoResumoAnaliseElegibilidadePreInsercaoTerritorioSubempresa;
                base.dadosDiagnostico =
                    resposta.diagnosticoSocioambiental || base.dadosDiagnostico;
                base.dadosCalculoRaio = resposta.raioTerritorio
                    ? {
                            ...base.dadosCalculoRaio,
                            ...resposta.raioTerritorio,
                            distanciaRaioMunicipioECar:
                                resposta.raioTerritorio.distanciaRaioMunicipioECar ??
                                resposta.raioTerritorio.distanciaRaioLocalidade
                        }
                    : base.dadosCalculoRaio;
                base.elegibilidade = resultado;
                base.territorioOutput =
                    resposta.territorioOutput || base.territorioOutput;
                base.saldoTerritorial =
                    resposta.buscarSaldoTerritorioPyOutput ?? base.saldoTerritorial;
                return base;
            },

            criarItemAnalisado(territorio, resposta) {
                return {
                    territorio,
                    dadosAnaliseElegibilidade: this.mapRespostaParaDadosAnalise(
                        resposta
                    ),
                    resultadoElegibilidade:
                        resposta.resultadoResumoAnaliseElegibilidadePreInsercaoTerritorioSubempresa,
                    volume: ''
                };
            },

            notificarErroTerritorioCadastrado(e) {
                const msg =
                    e?.response?.data?.message ??
                    'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.erroTerritorioCadastrado';
                this.$notify.error({ message: this.$t(msg) });
            },

            async enviarSelecionadosParaAnalise() {
                if (!this.idsSelecionadosParaAcao.length || this.loadingResumo) {
                    return;
                }
                const territorios = this.idsSelecionadosParaAcao
                    .map((id) =>
                        this.territoriosSelecionados.find((t) => t.id === id)
                    )
                    .filter(Boolean);
                if (!territorios.length) return;

                this.loadingResumo = true;
                try {
                    const body = this.buildBodyResumoElegibilidade(
                        this.idsSelecionadosParaAcao
                    );
                    const { data } =
                        await ContratoOriginacaoServiceSubEmpresa.buscarResumoAnaliseElegibilidadePreInsercaoTerritorioPy(
                            body
                        );
                    const resultados = Array.isArray(data) ? data : [data];
                    resultados.forEach((resposta, i) => {
                        if (territorios[i]) {
                            this.territoriosAnalisados.push(
                                this.criarItemAnalisado(territorios[i], resposta)
                            );
                        }
                    });
                    this.territoriosSelecionados = this.territoriosSelecionados.filter(
                        (t) => !this.idsSelecionadosParaAcao.includes(t.id)
                    );
                    this.idsSelecionadosParaAcao = [];
                } catch (e) {
                    this.notificarErroTerritorioCadastrado(e);
                } finally {
                    this.loadingResumo = false;
                }
            },

            corTagElegibilidade(resultado) {
                const map = {
                    ELEGIVEL: 'success',
                    INELEGIVEL: 'danger',
                    INDEFINIDO: 'info',
                    COM_ALERTA: 'warning'
                };
                return map[resultado] || 'info';
            },

            textoElegibilidade(resultado) {
                const map = {
                    ELEGIVEL: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.elegivel'
                    ),
                    INELEGIVEL: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.inelegivel'
                    ),
                    INDEFINIDO: '-',
                    COM_ALERTA: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.comAlerta'
                    )
                };
                return map[resultado] || '-';
            },

            getSaldoDisponivelItem(item) {
                const d = item?.dadosAnaliseElegibilidade;
                if (!d) return null;
                return d.saldoTerritorial?.saldoCapacidadeProdutiva ??
                    d.dadosBuscaSaldo?.saldoCARcapacidadeProdutiva ??
                    null;
            },

            volumeValido(volumeStr, item) {
                const volume = this.parseVolume(volumeStr);
                if (volume <= 0) return false;
                const saldo = item ? this.getSaldoDisponivelItem(item) : null;
                return saldo == null || volume <= saldo;
            },

            formatarVolumeAnalisado(idx) {
                const item = this.territoriosAnalisados[idx];
                if (!item || !item.volume) return;
                item.volume = formatters.formatarTonelada(item.volume);
                const saldo = this.getSaldoDisponivelItem(item);
                const excede = saldo != null && this.parseVolume(item.volume) > saldo;
                this.$set(
                    this.errosVolume,
                    idx,
                    excede
                        ? this.$t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.paraguai.erroVolumeSaldo')
                        : null
                );
            },

            async adicionarTerritorioDaListaAnalisados(item) {
                if (!this.volumeValido(item.volume)) {
                    this.$notify.warning({
                        message: this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.campoObrigatorio'
                        )
                    });
                    return;
                }
                this.itemInserindoId = item.territorio.id;
                try {
                    const { data } =
                        await ContratoOriginacaoServiceSubEmpresa.inserirDadosContratoPY(
                            this.buildPayloadInserirPY(item)
                        );
                    this.$notify.success({
                        message: data.mensagemCadastroSucesso
                    });
                    this.territoriosAnalisados = this.territoriosAnalisados.filter(
                        (i) => i.territorio.id !== item.territorio.id
                    );
                    this.$emit('territorio-inserido');
                } catch (error) {
                    this.exibirNotificacoesErros(error);
                } finally {
                    this.itemInserindoId = null;
                }
            },

            limparCPF() {
                this.formularioCadastroTerritorio.documentoPessoa = '';
                this.limparDadosResumo();
            },

            limparTerritorios() {
                this.formularioCadastroTerritorio.territorioSelecionado = '';
                this.limparDadosResumo();
            },

            validarTerritorioResumo() {
                this.$refs['formularioCadastroTerritorio'].validate(valid => {
                    if (valid) {
                        this.realizarResumo();
                    } else {
                        return false;
                    }
                });
            },

            handleDepartamentoChange() {
                if (this.formBuscaTerritorios.departamento) {
                    this.listarLocalidadeNivelDois(
                        this.formBuscaTerritorios.departamento
                    );
                    this.resetFieldIfNotEmpty('distrito');
                    }
            },

            handleDistritoClear() {
                this.resetFieldIfNotEmpty('distrito');
                },

            limparSelecao() {
                this.territorioSelecionado = null;
                this.territoriosSelecionados = [];
                this.territoriosAnalisados = [];
                this.idsSelecionadosParaAcao = [];
                this.idsSelecionadosParaAdicionarLista = [];
                this.buscaRealizada = false;
                this.formularioCadastroTerritorio.documentoPessoa = '';
                this.formularioCadastroTerritorio.idTerritorio = '';
                this.tipoSelecao = '';
                this.limparDadosResumo();
            },

            resetFieldIfNotEmpty(field) {
                if (this.formBuscaTerritorios[field]) {
                    this.formBuscaTerritorios[field] = '';
                }
            },

            async buscarTerritorio() {
                this.buscandoTerritorio = true;
                this.buscaRealizada = false;
                this.territorioSelecionado = null;

                try {
                    const validacao = await this.validarFormulario();
                    if (!validacao) return;

                    const parametrosBusca = this.prepararParametrosBusca();
                    const resultado = await this.realizarBuscaAPI(parametrosBusca);

                    if (resultado && resultado.length > 0) {
                        this.territoriosVinculados = resultado;
                        this.$emit('modal-territorios', resultado);
                        this.tipoSelecao = 'localizacao';
                    } else {
                        this.$messageBox.alert(
                            this.$t(
                                'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.argentina.sistemaNaoIndentificouTerritorio'
                            ),
                            this.$t(
                                'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.aviso'
                            ),
                            {
                                confirmButtonText: 'Ok',
                                type: 'info',
                                customClass: 'message-box-infor-sub-empresa-manual'
                            }
                        );
                    }
                } catch (error) {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.erroRequisicao'
                        )
                    });
                } finally {
                    this.buscandoTerritorio = false;
                    this.buscaRealizada = true;
                }
            },

            async validarFormulario() {
                return new Promise(resolve => {
                    this.$refs['formCadastroManualRef'].validate(valid => {
                        if (!valid) {
                            this.$notify.error({
                                message: this.$t(
                                    'mensagens.territorio.preenchaCamposObrigatorios'
                                ),
                                duration: 3000
                            });
                        }
                        resolve(valid);
                    });
                });
            },

            prepararParametrosBusca() {
                const { distrito, departamento, padron, finca } =
                    this.formBuscaTerritorios;

                return {
                    distrito: distrito || null,
                    departamento: departamento || null,
                    padron: padron || null,
                    finca: finca || null
                };
            },

            async realizarBuscaAPI(parametros) {
                try {
                    const response =
                        await TerritorioService.buscarTerritoriosRevendaPY(
                            parametros
                        );

                    return response.data.itens || [];
                } catch (error) {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.erroRequisicao'
                        )
                    });
                    return [];
                }
            },

            getDepartamentoDistritoTexto() {
                if (this.territorioSelecionado) {
                    const { departamento, distrito, departamentoNome, distritoNome } = this.territorioSelecionado;
                    if (departamento && distrito) {
                        return `${distrito.nome} / ${departamento.nome}`;
                    } else if (departamentoNome && distritoNome) {
                        return `${distritoNome} / ${departamentoNome}`;
                    }
                    return this.$t('mensagens.sig.erro.naoinformado');
                }
                return this.$t('mensagens.sig.erro.naoinformado');
            },

            async realizarResumo() {
                if (!this.territorioSelecionado) return;
                this.limparDadosResumo();
                this.showResumoElegibilidade = true;
                this.loadingResumo = true;
                const territorio = this.territorioSelecionado;
                try {
                    const body = this.buildBodyResumoElegibilidade([territorio.id]);
                    const { data } =
                        await ContratoOriginacaoServiceSubEmpresa.buscarResumoAnaliseElegibilidadePreInsercaoTerritorioPy(
                            body
                        );
                    const resposta = Array.isArray(data) ? data[0] : data;
                    this.territoriosAnalisados.push(
                        this.criarItemAnalisado(territorio, resposta)
                    );
                    this.territoriosSelecionados = this.territoriosSelecionados.filter(
                        (t) => t.id !== territorio.id
                    );
                    this.idsSelecionadosParaAcao = this.idsSelecionadosParaAcao.filter(
                        (id) => id !== territorio.id
                    );
                    this.territorioSelecionado = null;
                    this.showResumoElegibilidade = false;
                    this.limparDadosResumo();
                } catch (e) {
                    this.notificarErroTerritorioCadastrado(e);
                    this.showResumoElegibilidade = false;
                } finally {
                    this.loadingResumo = false;
                }
            },

            validarTerritorioManual() {
                let temErroForm = false;
                this.$refs['formularioCadastroTerritorio'].validate(valid => {
                    if (!valid) {
                        temErroForm = true;
                    }
                });

                if (!temErroForm) {
                    this.adicionarTerritorioListagem();
                }
            },

            async adicionarTerritorioListagem() {
                this.territorioSendoInserido = true;

                try {
                    const contrato = {
                        idTerritorio:
                            this.formularioCadastroTerritorio.territorioSelecionado
                                .id,
                        numeroContrato: this.numeroContrato,
                        volume: parseFloat(
                            this.formularioCadastroTerritorio.volumeTerritorio.replace(
                                ',',
                                '.'
                            )
                        ),
                        documentoRepresentante:
                            this.formularioCadastroTerritorio.documentoPessoa,
                        idRepresentante:
                            this.formularioCadastroTerritorio.documentoPessoa
                    };

                    const response =
                        await ContratoOriginacaoServiceSubEmpresa.inserirDadosContratoPY(
                            contrato
                        );

                    this.$notify.success({
                        message: response.data.mensagemCadastroSucesso
                    });

                    this.$emit('territorio-inserido');
                    this.resetFormularioCompleto();
                } catch (error) {
                    this.exibirNotificacoesErros(error);
                } finally {
                    this.territorioSendoInserido = false;
                }
            },

            exibirNotificacoesErros(error) {
                if (error.response?.data?.type === 'MEDIA_CAPACIDADE_REGIONAL') {
                    this.$emit('mostrar-modal-capacidade', error.response.data);
                } else if (
                    error.response?.data?.type === 'FORA_DO_RAIO_PERMITIDO'
                ) {
                    this.$messageBox.alert(
                        error.response.data.message,
                        error.response.data.title,
                        {
                            confirmButtonText: 'Voltar',
                            type: 'warning'
                        }
                    );
                } else {
                    this.$notify.error({
                        message:
                            error.response?.data?.message ||
                            'Erro ao inserir território'
                    });
                }
            },

        formatarRuc(cpfCnpj) {
            return formatters.numeralStringFormatTocpfCnpj(cpfCnpj, 'PY');
        },

        volumeRecebidoFormatado() {
            this.formularioCadastroTerritorio.volumeTerritorio =
                formatters.formatarTonelada(
                    this.formularioCadastroTerritorio.volumeTerritorio
                );
        },

        modalAnaliseElegibilidade() {
            if (this.loadingResumo) return;

            this.dadosAnaliseElegibilidade.safraNome = this.dados.safraNome;
            this.$emit('emitir-elegibilidade', this.dadosAnaliseElegibilidade);
        },

        limparDadosResumo() {
            this.showResumoElegibilidade = false;
            this.dadosAnaliseElegibilidade = this.getInitialDadosAnalise();
            this.resultadoElegibilidade = 'INDEFINIDO';
        },

        formatSaldoDisponivel(dadosAnalise) {
            if (!dadosAnalise) return '-';

            const saldo =
                dadosAnalise.saldoTerritorial &&
                dadosAnalise.saldoTerritorial.saldoCapacidadeProdutiva !== null
                    ? dadosAnalise.saldoTerritorial.saldoCapacidadeProdutiva
                    : dadosAnalise.dadosBuscaSaldo &&
                        dadosAnalise.dadosBuscaSaldo.saldoCARcapacidadeProdutiva !== null
                        ? dadosAnalise.dadosBuscaSaldo.saldoCARcapacidadeProdutiva
                        : null;

            if (saldo === null || saldo === undefined) {
                return '-';
            }

            return formatters.formatarTonelada(saldo);
        },

        formatDistancia(dadosAnalise) {
            if (
                !dadosAnalise ||
                !dadosAnalise.dadosCalculoRaio ||
                dadosAnalise.dadosCalculoRaio.distanciaRaioLocalidade === null ||
                dadosAnalise.dadosCalculoRaio.distanciaRaioLocalidade === undefined
            ) {
                return '-';
            }

            return `${dadosAnalise.dadosCalculoRaio.distanciaRaioLocalidade} km`;
        },

        abrirDetalhesElegibilidade(item) {
            if (!item || !item.dadosAnaliseElegibilidade) return;

            const payload = {
                ...item.dadosAnaliseElegibilidade,
                elegibilidade: item.resultadoElegibilidade
            };
            if (this.dados?.safraNome) {
                payload.safraNome = this.dados.safraNome;
            }
            this.$emit('emitir-elegibilidade', payload);
        },

        resetFormularioCompleto() {
            this.formBuscaTerritorios = {
                padron: '',
                departamento: '',
                distrito: '',
                finca: ''
            };
            this.formularioCadastroTerritorio = {
                volumeTerritorio: '',
                territorioSelecionado: '',
                documentoPessoa: ''
            };

            this.$nextTick(() => {
                if (this.$refs.formCadastroManualRef) {
                    this.$refs.formCadastroManualRef.clearValidate();
                }
                if (this.$refs.formularioCadastroTerritorio) {
                    this.$refs.formularioCadastroTerritorio.clearValidate();
                }
            });

            this.territoriosVinculados = [];
            this.representantes = [];
            this.distritos = [];
            this.localidades = [];
            this.tipoSelecao = '';
            this.limparDadosResumo();
            this.limparSelecao();
        },

        alertRepresentanteSemTerritorios() {
            this.$messageBox.alert(
                this.$t(
                    'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.sistemaNaoIndentificouPY'
                ),
                this.$t(
                    'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.aviso'
                ),
                {
                    confirmButtonText: 'Ok',
                    type: 'info',
                    customClass: 'message-box-infor-sub-empresa-manual'
                }
            );
        },

        orderName(a, b) {
            const nameA = a.label.toUpperCase();
            const nameB = b.label.toUpperCase();
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
        },

        async listarLocalidadeNivelUm() {
            try {
                this.carregandoNivelUm = true;
                const { data } =
                    await LocalidadeService.buscarLocalidadeNivelUm();

                const dataFormat = data
                    .map(item => ({ label: item.nome, id: item.id }))
                    .sort((a, b) => this.orderName(a, b));

                this.departamentos = dataFormat;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.pessoas.erroBuscarLocalidadeNivelUm'
                    )
                });
            } finally {
                this.carregandoNivelUm = false;
            }
        },

        async listarLocalidadeNivelDois(id) {
            try {
                this.carregandoNivelDois = true;
                const { data } =
                    await LocalidadeService.buscarLocalidadeNivelDois(id);

                const dataFormat = data
                    .map(item => ({ label: item.nome, id: item.id }))
                    .sort((a, b) => this.orderName(a, b));

                this.distritos = dataFormat;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.pessoas.erroBuscarLocalidadeNivelDois'
                    )
                });
            } finally {
                this.carregandoNivelDois = false;
            }
        },

        validateRUC(ruc) {
            const regexFormat = /^(\d|\.|-)+$/;
            const regexAdjust = /\D/gi;
            const baseMod = 11;

            if (!ruc || !regexFormat.test(ruc)) return false;

            const adjustedRuc = ruc.replace(regexAdjust, '');
            if (![8, 9].includes(adjustedRuc.length)) return false;

            const identityDigitsLength = adjustedRuc.length - 2;
            let valueSum = 0;
            let increasingSequenceQtd = 0;
            let decreasingSequenceQtd = 0;
            let equalsDigitQtd = 0;

            for (
                let index = identityDigitsLength, multiplier = 2;
                index >= 0;
                index--, multiplier++
            ) {
                valueSum += Number(adjustedRuc[index]) * multiplier;

                if (index > 0) {
                    const previousDigit = Number(adjustedRuc[index - 1]);
                    const currentDigit = Number(adjustedRuc[index]);
                    if (previousDigit === currentDigit) equalsDigitQtd++;
                    if (currentDigit > previousDigit) increasingSequenceQtd++;
                    if (previousDigit > currentDigit) decreasingSequenceQtd++;
                }
            }
            if (
                increasingSequenceQtd >= 6 ||
                decreasingSequenceQtd >= 6 ||
                equalsDigitQtd >= 6
            ) {
                return false;
            }

            const mod = valueSum % baseMod;
            const verifyDigit = mod > 1 ? baseMod - mod : 0;

            return (
                adjustedRuc[identityDigitsLength + 1] === verifyDigit.toString()
            );
        },

        abrirModalBuscarTerritorios() {
            this.showModalBuscarTerritorios = true;
        },

        fecharModalBuscarTerritorios() {
            this.showModalBuscarTerritorios = false;
        },

        handleTerritorioSelecionadoModal(territorios) {
            const lista = Array.isArray(territorios) ? territorios : [territorios];
            this.definirTerritoriosSelecionados(lista);
            this.fecharModalBuscarTerritorios();
            this.tipoSelecao = 'cadastrado';
        }
    }
};
</script>

<style lang="scss" scoped>
.buscar-territorios-py {
    padding-top: 20px;
    width: 100%;

    h1 {
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 10px;
    }

    .el-card {
        margin-top: 10px;
        display: flex;

        :deep(.el-card__body) {
            width: 100%;
        }
    }

    .box-card-inserir-dados-manual__conteudo {
        display: flex;
        flex-direction: column;
        align-content: space-around;
        justify-content: space-between;
        gap: 10px;

        .el-alert {
            :deep(el-alert__description) {
                font-size: 14px !important;
            }
        }

        .secao-titulo {
            font-weight: bold;
            font-size: 16px;
            padding: 8px 0px;
            color: var(--primary-font-color);
        }

        .secoes-busca-container {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 30px;
            margin-top: 30px;
            border-bottom: 1px solid #e0e0e0;
            padding-bottom: 25px;

            .secao-busca-doc {
                border-right: 1px solid #e0e0e0;
                padding-right: 25px;
                display: flex;
                flex-direction: column;
            }

            .secao-busca-territorios-cadastrados {
                display: flex;
                flex-direction: column;
            }
        }

        .secao-titulo-territorios {
            font-weight: bold;
            font-size: 16px;
            color: var(--primary-font-color);
            margin-top: 0;
            margin-bottom: 15px;
        }

        .secao-busca-territorios-cadastrados {
            .secao-descricao {
                font-size: 14px;
                color: var(--secondary-font-color);
                line-height: 1.6;
                margin-bottom: auto;
            }

            .el-button {
                width: 100%;
                height: 40px;
                margin-top: auto;
                margin-bottom: 0.55rem;
            }
        }

        .secao-busca-doc {
            .secao-descricao {
                font-size: 14px;
                color: var(--secondary-font-color);
                line-height: 1.6;
                margin-bottom: 15px;
            }

            .secao-dica {
                font-size: 12px;
                color: var(--secondary-font-color);
                line-height: 1.5;
                margin-bottom: 10px;
                font-style: italic;
            }
        }

        .secao-pesquisa-documento {
            margin-top: 5px;
            display: flex;
            flex-direction: column;
            flex: 1;

            .form-pesquisa-documento {
                display: flex;
                flex-direction: column;
                flex: 1;

                .box-card-inserir-dados-manual__conteudo__bloco_pesquisa-por-territorio {
                    display: flex;
                    flex-direction: column;
                    margin-bottom: 15px;
                    flex: 1;

                    &.width-direito {
                        width: 100% !important;
                        margin-bottom: 0px;
                        display: flex;
                        flex-direction: column;
                        flex: 1;
                    }

                    .input-pesquisa-por-territorio-container {
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        width: 100%;
                        margin-top: auto;
                    }

                    .input-pesquisa-por-territorio {
                        display: flex;
                        flex: 1;
                        min-width: 0;

                        .el-select {
                            width: 100%;
                        }
                    }

                    .input-pesquisa-por-territorio-container {
                        .el-button {
                            height: 40px;
                            border-radius: 4px;
                            padding: 12px 35px;
                            white-space: nowrap;
                            flex-shrink: 0;
                        }
                    }
                }

                .box-card-inserir-dados-manual__conteudo__bloco__buttons {
                    display: flex;
                    justify-content: flex-end;
                    gap: 15px;
                    margin-top: 15px;

                    button.el-button.el-button--primary {
                        width: 100%;
                        height: 40px;
                    }
                }
            }
        }

        .secao-localizacao {
            .formTerritorios {
                display: grid;
                grid-template-columns: repeat(5, 1fr);
                gap: 10px 20px;
                margin-bottom: 17px;

                .el-select {
                    width: 100%;
                }

                button {
                    height: 40px;
                    margin-top: auto;
                    margin-bottom: 9px;
                }
            }

            .accordion-territorios-selecionados {
                margin-top: 20px;

                :deep(.el-collapse-item__header) {
                    font-weight: bold;
                    font-size: 15px;
                    color: var(--primary-font-color);
                }

                :deep(.el-collapse-item__wrap) {
                    border-bottom: 1px solid #ebeef5;
                }
            }

            .listas-territorios-container {
                display: flex;
                flex-direction: column;
                gap: 0;
                padding: 16px 12px 16px 0;
                max-height: 600px;
                overflow-y: auto;
                overflow-x: hidden;

                &::-webkit-scrollbar {
                    width: 6px;
                }

                &::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 3px;
                }

                &::-webkit-scrollbar-thumb {
                    background: #c1c1c1;
                    border-radius: 3px;

                    &:hover {
                        background: #a8a8a8;
                    }
                }

                .lista-pendentes {
                    display: flex;
                    flex-direction: column;
                    padding-bottom: 20px;
                }

                .lista-analisados {
                    display: flex;
                    flex-direction: column;
                    padding-top: 20px;

                    .lista-territorios-table {
                        border: 1px solid #ebeef5;
                        border-radius: 4px;
                        overflow: hidden;

                        :deep(.el-table) {
                            border: none;
                        }

                        :deep(.el-table::before) {
                            display: none;
                        }

                        :deep(.el-table td),
                        :deep(.el-table th) {
                            border-right: none;
                        }

                        :deep(.el-table td:first-child),
                        :deep(.el-table th:first-child) {
                            border-left: none;
                        }
                    }
                }

                :deep(.el-divider) {
                    margin: 20px 0 !important;
                    display: block !important;
                    height: 1px !important;
                    min-height: 1px !important;
                }

                :deep(.el-divider--horizontal) {
                    display: block !important;
                    height: 1px !important;
                    min-height: 1px !important;
                    margin: 20px 0 !important;
                }

                .lista-header {
                    margin-bottom: 16px;
                }

                .lista-titulo-container {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                }

                .lista-titulo {
                    font-size: 16px;
                    font-weight: 600;
                    color: var(--primary);
                    margin: 0;
                    padding: 0;
                    display: flex;
                    align-items: center;
                    flex: 1;
                }

                .lista-badge {
                    flex-shrink: 0;

                    :deep(.el-badge__content) {
                        background-color: var(--primary);
                        font-weight: 600;
                    }
                }

                .lista-descricao {
                    font-size: 13px;
                    color: #666;
                    line-height: 1.5;
                    margin: 0;
                }

                .lista-territorios-table {
                    margin-bottom: 16px;
                    border-bottom: 1px solid #e0e0e0;

                    :deep(.el-table__header-wrapper) {
                        .table-header-with-icon {
                            display: flex;
                            align-items: center;
                            gap: 6px;
                            justify-content: flex-start;

                            .table-header-icon {
                                font-size: 16px;
                                color: var(--primary);
                                flex-shrink: 0;
                            }
                        }

                        th:nth-child(2) {
                            /* Remove borda esquerda do header de Território */
                            border-left-color: transparent !important;
                        }
                    }

                    :deep(.el-table__header th) {
                        text-align: left !important;
                        border-right: none !important;

                        .cell {
                            text-align: left !important;
                        }

                        .table-header-with-icon {
                            justify-content: flex-start;
                        }
                    }

                    :deep(.el-table__body-wrapper) {
                        td {
                            text-align: left !important;

                            .cell {
                                text-align: left !important;
                            }
                        }

                        /* Linha de dados do território sempre branca; só a linha expandida (diagnóstico) fica cinza */
                        tr.el-table__row {
                            background-color: #fff !important;

                            td {
                                background-color: #fff !important;
                            }
                        }

                    }

                    /* Coluna fixa do ícone expandir e coluna fixa de ações: fundo branco na linha de dados */
                    :deep(.el-table__fixed),
                    :deep(.el-table__fixed-right) {
                        tr.el-table__row td {
                            background-color: #fff !important;
                        }
                    }

                    :deep(.el-checkbox) {
                        .el-checkbox__label {
                            display: none !important;
                        }
                    }

                    .table-cell-territorio {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        flex-wrap: wrap;

                        .table-nome {
                            font-weight: 400;
                            font-size: 14px;
                            color: #333;
                            word-break: break-word;
                            flex: 1;
                            min-width: 0;
                        }
                    }

                    .table-volume-container {
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        gap: 8px;

                        .table-volume-input {
                            width: 200px;
                        }

                        .input-volume-erro {
                            width: 100%;
                            font-size: 12px;
                            color: #f56c6c;
                            line-height: 1.2;
                            margin-top: -4px;
                        }

                        .table-help-icon {
                            color: #999;
                            font-size: 14px;
                            cursor: help;
                            flex-shrink: 0;
                        }
                    }

                    :deep(.el-table__expanded-cell) {
                        padding: 0 !important;
                        background-color: #fafafa !important;
                    }

                    :deep(.el-table__expand-column .cell) {
                        padding: 0 !important;
                    }

                    &.lista-territorios-table--analisados {
                        :deep(.el-table__expand-column .el-table__expand-icon) {
                            display: none;
                        }

                        :deep(.el-table__expand-column .cell) {
                            display: block;
                            width: 0;
                            overflow: hidden;
                            padding: 0 !important;
                        }

                        :deep(.el-table__expanded-cell) {
                            display: table-cell !important;
                        }
                    }

                    .box-espande-listagem {
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        gap: 3rem;
                        padding: 10px 58px 16px 100px;
                        background-color: #fafafa;

                        .box-espande-listagem-box {
                            display: flex;
                            align-items: center;
                            gap: 6px;
                            font-size: 13px;

                            .box-espande-listagem-box-texto {
                                font-weight: 600;
                                color: var(--primary);
                            }

                            .bt-link {
                                padding: 0;
                                margin: 0;
                                color: var(--primary);
                                font-size: inherit;
                                font-weight: 400;
                                text-decoration: underline;

                                &:hover {
                                    color: var(--primary);
                                    background: transparent;
                                }
                            }

                            .box-espande-listagem-box-value {
                                font-weight: 400;
                                color: var(--primary-font-color);
                                display: flex;
                                align-items: center;
                                gap: 8px;
                            }
                        }

                        .box-espande-listagem-box--acao {
                            margin-left: auto;

                            .el-button {
                                width: 100%;
                                min-width: 112px;
                            }
                        }
                    }
                }

                .lista-vazia {
                    padding: 20px;
                    text-align: center;
                    border: 1px dashed #d0d0d0;
                    border-radius: 8px;
                    background: #fafafa;
                }

                .item-territorio {
                    display: flex;
                    align-items: flex-start;
                    gap: 14px;
                    padding: 16px;
                    margin-bottom: 12px;
                    background: #fff;
                    border-radius: 8px;
                    border: 1px solid #e8e8e8;
                    transition: all 0.2s ease;
                    position: relative;

                    &:hover {
                        border-color: var(--primary);
                        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
                        transform: translateY(-1px);
                    }

                    &:last-child {
                        margin-bottom: 0;
                    }

                    .item-territorio-checkbox {
                        flex-shrink: 0;
                        padding-top: 2px;

                        :deep(.el-checkbox) {
                            margin: 0;

                            .el-checkbox__label {
                                display: none;
                            }
                        }
                    }

                    .item-territorio-content {
                        flex: 1;
                        min-width: 0;
                        display: flex;
                        flex-direction: column;
                        gap: 12px;
                    }

                    .item-territorio-header-card {
                        display: flex;
                        align-items: flex-start;
                        gap: 10px;
                        padding-bottom: 8px;
                        border-bottom: 1px solid #f0f0f0;

                        .item-header-icon {
                            font-size: 18px;
                            color: var(--primary);
                            flex-shrink: 0;
                            margin-top: 2px;
                        }

                        .item-header-info {
                            flex: 1;
                            min-width: 0;
                        }

                        .item-nome-com-id {
                            display: flex;
                            align-items: center;
                            gap: 10px;
                            flex-wrap: wrap;
                            line-height: 1.4;
                        }

                        .item-nome {
                            font-weight: 600;
                            font-size: 15px;
                            color: #333;
                            word-break: break-word;
                            flex: 1;
                            min-width: 0;
                        }

                        .item-id {
                            font-size: 12px;
                            color: #999;
                            font-weight: 500;
                            font-family: 'Courier New', monospace;
                            background: #f5f5f5;
                            padding: 2px 8px;
                            border-radius: 4px;
                            white-space: nowrap;
                            flex-shrink: 0;
                        }
                    }

                    .item-territorio-grid {
                        display: flex;
                        flex-direction: column;
                        gap: 10px;

                        .item-grid-row {
                            display: grid;
                            grid-template-columns: repeat(2, 1fr);
                            gap: 10px;

                            @media (max-width: 768px) {
                                grid-template-columns: 1fr;
                            }

                            &.item-grid-row-full {
                                grid-template-columns: 1fr;
                            }
                        }

                        .item-grid-item {
                            display: flex;
                            align-items: flex-start;
                            gap: 8px;
                            padding: 10px;
                            background: #f8f9fa;
                            border-radius: 6px;
                            transition: all 0.2s ease;
                            border: 1px solid transparent;

                            &:hover {
                                background: #f0f2f5;
                                border-color: #e0e0e0;
                            }

                            .item-icon {
                                font-size: 18px;
                                color: var(--primary);
                                margin-top: 2px;
                                flex-shrink: 0;
                                width: 20px;
                                text-align: center;
                            }

                            .item-grid-content {
                                flex: 1;
                                min-width: 0;
                                display: flex;
                                flex-direction: column;
                                gap: 4px;
                            }

                            .item-grid-label {
                                font-size: 11px;
                                font-weight: 600;
                                color: #666;
                                text-transform: uppercase;
                                letter-spacing: 0.5px;
                                line-height: 1.3;
                            }

                            .item-grid-value {
                                font-size: 13px;
                                font-weight: 500;
                                color: #333;
                                line-height: 1.4;
                                word-break: break-word;
                            }
                        }
                    }
                }

                .item-territorio-analisado {
                    display: flex;
                    flex-direction: column;
                    gap: 14px;
                    padding: 16px;
                    margin-bottom: 12px;
                    background: #fff;
                    border-radius: 8px;
                    border: 1px solid #e8e8e8;
                    transition: all 0.2s ease;
                    position: relative;

                    &:hover {
                        border-color: var(--primary);
                        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
                        transform: translateY(-1px);
                    }

                    &:last-child {
                        margin-bottom: 0;
                    }

                    .item-territorio-content {
                        flex: 1;
                        min-width: 0;
                        display: flex;
                        flex-direction: column;
                        gap: 12px;
                    }

                    .item-territorio-header-card {
                        display: flex;
                        align-items: flex-start;
                        gap: 10px;
                        padding-bottom: 8px;
                        border-bottom: 1px solid #f0f0f0;

                        .item-header-icon {
                            font-size: 18px;
                            color: var(--primary);
                            flex-shrink: 0;
                            margin-top: 2px;
                        }

                        .item-header-info {
                            flex: 1;
                            min-width: 0;
                            display: flex;
                            flex-direction: column;
                            gap: 8px;
                        }

                        .item-nome-com-id {
                            display: flex;
                            align-items: center;
                            gap: 10px;
                            flex-wrap: wrap;
                            line-height: 1.4;
                        }

                        .item-nome {
                            font-weight: 600;
                            font-size: 15px;
                            color: #333;
                            word-break: break-word;
                            flex: 1;
                            min-width: 0;
                        }

                        .item-id {
                            font-size: 12px;
                            color: #999;
                            font-weight: 500;
                            font-family: 'Courier New', monospace;
                            background: #f5f5f5;
                            padding: 2px 8px;
                            border-radius: 4px;
                            white-space: nowrap;
                            flex-shrink: 0;
                        }

                        .item-tag-container {
                            display: flex;
                            align-items: center;
                            gap: 8px;
                        }
                    }

                    .item-territorio-grid {
                        display: flex;
                        flex-direction: column;
                        gap: 10px;

                        .item-grid-row {
                            display: grid;
                            grid-template-columns: repeat(2, 1fr);
                            gap: 10px;

                            @media (max-width: 768px) {
                                grid-template-columns: 1fr;
                            }

                            &.item-grid-row-full {
                                grid-template-columns: 1fr;
                            }
                        }

                        .item-grid-item {
                            display: flex;
                            align-items: flex-start;
                            gap: 8px;
                            padding: 10px;
                            background: #f8f9fa;
                            border-radius: 6px;
                            transition: all 0.2s ease;
                            border: 1px solid transparent;

                            &:hover {
                                background: #f0f2f5;
                                border-color: #e0e0e0;
                            }

                            .item-icon {
                                font-size: 18px;
                                color: var(--primary);
                                margin-top: 2px;
                                flex-shrink: 0;
                                width: 20px;
                                text-align: center;
                            }

                            .item-grid-content {
                                flex: 1;
                                min-width: 0;
                                display: flex;
                                flex-direction: column;
                                gap: 4px;
                            }

                            .item-grid-label {
                                font-size: 11px;
                                font-weight: 600;
                                color: #666;
                                text-transform: uppercase;
                                letter-spacing: 0.5px;
                                line-height: 1.3;
                            }

                            .item-grid-value {
                                font-size: 13px;
                                font-weight: 500;
                                color: #333;
                                line-height: 1.4;
                                word-break: break-word;
                            }
                        }
                    }

                    .item-territorio-actions-card {
                        display: flex;
                        flex-direction: column;
                        gap: 10px;
                        padding-top: 12px;
                        border-top: 1px solid #f0f0f0;
                        width: 100%;
                        margin-top: 4px;

                        .item-volume-container {
                            display: flex;
                            flex-direction: column;
                            gap: 8px;
                            width: 100%;

                            .item-volume-label-container {
                                display: flex;
                                align-items: center;
                                gap: 6px;

                                .item-volume-label {
                                    font-size: 12px;
                                    font-weight: 500;
                                    color: #555;
                                    margin: 0;
                                }

                                .item-help-icon {
                                    color: #999;
                                    font-size: 14px;
                                    cursor: help;
                                    flex-shrink: 0;
                                }
                            }

                            .item-volume-input-container {
                                display: flex;
                                align-items: center;
                                gap: 10px;
                                width: 100%;

                                .item-volume {
                                    width: 200px;
                                    flex-shrink: 0;
                                }

                                .el-button {
                                    flex-shrink: 0;
                                    white-space: nowrap;
                                }
                            }
                        }
                    }
                }

                .item-nome {
                    font-weight: 600;
                    font-size: 14px;
                    color: #333;
                    line-height: 1.4;
                    word-break: break-word;
                }

                .item-detalhes {
                    font-size: 12px;
                    color: #666;
                    line-height: 1.4;
                    word-break: break-word;
                    display: flex;
                    gap: 6px;
                    margin-top: 4px;

                    .item-label {
                        font-weight: 500;
                        color: #555;
                    }
                }

                .lista-alerta-info {
                    margin-top: 12px;
                    margin-bottom: 8px;

                    :deep(.el-alert__content) {
                        padding-top: 0;
                    }
                }

                .lista-acoes {
                    padding-right: 0;
                }

                .lista-botoes {
                    display: flex;
                    gap: 10px;
                    margin-top: 12px;
                    flex-wrap: wrap;
                    align-items: center;
                    justify-content: flex-end;

                    .el-button {
                        flex: none;
                    }

                    .botao-analisar-container {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        flex: none;

                        .lista-info-icon {
                            color: var(--primary);
                            font-size: 16px;
                            cursor: help;
                            flex-shrink: 0;
                        }
                    }
                }

                .item-territorio-header {
                    display: flex;
                    align-items: flex-start;
                    justify-content: space-between;
                    gap: 12px;
                    flex-wrap: wrap;
                    margin-bottom: 8px;

                    .item-header-info {
                        flex: 1;
                        min-width: 0;
                    }
                }

                .item-volume-container {
                    display: flex;
                    flex-direction: column;
                    gap: 6px;
                    flex: 1;
                    min-width: 120px;
                    max-width: 200px;

                    .item-volume-label {
                        font-size: 12px;
                        font-weight: 500;
                        color: #555;
                        display: flex;
                        align-items: center;
                        gap: 4px;
                    }

                    .item-help-icon {
                        color: #999;
                        font-size: 12px;
                        cursor: help;
                    }

                    .item-volume {
                        width: 100%;
                    }
                }
            }
        }
    }

    .input-car-cpf-cnpj {
        :deep(.el-input__inner) {
            border-radius: 4px !important;
        }
    }

    i.el-tooltip.el-icon-info.dados-manual {
        margin-left: 4px;
    }

    .input-pesquisa-por-representante-select {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .direita {
            font-size: 12px;
            color: #666;
        }
    }
}
</style>
